import React, { useReducer, useEffect } from "react";

import AuthContext from "./AuthContext";
import AuthReducer from "./AuthReducer";
import axios from "axios";
// import { DateTime , Settings  } from 'luxon';
// import luxon from 'luxon';
//import data from "../../data/projects.json";

import {
  SET_AUTH_STATUS,
  SET_AUTH_USER,
  SET_AUTHORIZED,
  LOGIN,
  LOGOUT,
} from "../../data/constants";

//const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const AuthState = (props: {
  children:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | Iterable<React.ReactNode>
    | React.ReactPortal
    | null
    | undefined;
}) => {
  //const localState = window.localStorage.getItem("jsi-intelli-project");
  const initUserEntry = localStorage.getItem("authUser");
  // console.log("Init User:", initUserEntry);

  const initUser =
    typeof initUserEntry !== "undefined" &&
    initUserEntry &&
    initUserEntry.length > 0
      ? JSON.parse(localStorage.getItem("authUser") || "null")
      : null;
  const initialState = {
    isAuthenticated: false,
    authUser: initUser,
    userRoles: [],
    // {
    //   loginId: "",
    //   roleId: 0,
    //   roleName: "",
    //   userId: 0,
    //   userName: "anonymous",
    // },
    loading: false,
    error: null,
    portalUser: null,
    isPortalAuthenticated: localStorage.getItem("isPortalAuthenticated")
      ? localStorage.getItem("isPortalAuthenticated")
      : false,
  };

  // console.log("Init State:", initialState);
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const setAuthStatus = (
    status: any,
    userId: any,
    roleType: any,
    authId: any
  ) => {
    // console.log("Search for", search);
    const payload: any = {
      isAuthenticated: status,
    };
    // if (userId) payload.authUserId = userId;
    if (authId) payload.authId = authId;
    if (roleType) payload.roleType = roleType;
    dispatch({
      type: SET_AUTH_STATUS,
      payload,
    });
  };

  const setAuthUser = (user: any) => {
    // console.log("Settign Auth User:", user);
    dispatch({
      type: SET_AUTH_USER,
      payload: user,
    });
  };

  const setAuthorized = (flag: any) => {
    dispatch({
      type: SET_AUTHORIZED,
      payload: flag,
    });
  };

  const logout = () => {
    dispatch({
      type: LOGOUT,
      payload: {
        user: undefined,
        token: undefined,
      },
    });
  };

  const loadUser = async () => {
    console.log("LOADING USER ...");
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get("/user-detail", config);
        console.log("USER STATE", res, res.data.token);
        // localStorage.setItem("isAuthenticated", JSON.stringify(response.data));

        dispatch({
          type: LOGIN,
          payload: { user: res.data.user, token: res.data.token },
        });
        resolve(res.data.user);
      } catch (err) {
        // // console.log("Error", err);
        reject(null);
      }
    });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        setAuthStatus,
        setAuthUser,
        setAuthorized,
        loadUser,
        logout,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
